import { render, staticRenderFns } from "./DataTableHeaderCell.vue?vue&type=template&id=7d096da3&"
import script from "./DataTableHeaderCell.vue?vue&type=script&lang=js&"
export * from "./DataTableHeaderCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports